export const getUrl = (collection, slug, categories) => {
    let source = ''
    switch (collection) {
    case 'collectionWebProfiles':
    case 'collectionSaleProfiles':
    case 'collectionSearch':
        source = 'motorcars'
        break;
    default:
        source = categories[0] || ''
        break;
    }
    return `/${source}/${slug}`
}
